import * as React from 'react';

import { extractErrorInfo } from '../../utility/error';
import { LogManager } from '../../utility/Logger';

const logger = LogManager.getLogger('ErrorBoundary');

interface ErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export default class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    logger.error('componentDidCatch', {
      error,
      componentStack: info.componentStack,
      errorInfo: extractErrorInfo(error),
    });
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <section role="alert" aria-label="Application error">
            Unexpected application error
          </section>
        )
      );
    }
    return this.props.children;
  }
}
